import { render, staticRenderFns } from "./NotificationBlock.vue?vue&type=template&id=5812deae&scoped=true&"
import script from "./NotificationBlock.vue?vue&type=script&lang=js&"
export * from "./NotificationBlock.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBlock.vue?vue&type=style&index=0&id=5812deae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5812deae",
  null
  
)

component.options.__file = "NotificationBlock.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDivider,
  VIcon,
  VList,
  VListTile,
  VListTileContent,
  VListTileSubTitle,
  VMenu,
})
